export default __webpack_public_path__ + "static/helix-bq-4-a6b6794bd667f949d4adc9347db49ccf.jpg";